import React, { Component } from 'react'
import { Header, Icon , Button, Divider, Modal} from 'semantic-ui-react'
import "react-table/react-table.css";
import LicenseAccessList from './LicenseAccessList'
import LicenseAccessAdd from "./LicenseAccessAdd";




class LicenseAccessManagement extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.getLicenseAccess();
        this.props.getUserEmails();
    }
    render() {
        /*console.log(this.props.data)
        console.log(this.props.type)*/
        return (
            <React.Fragment>
                {{ // Mimic switch
                    listLicenseAccess: (<LicenseAccessList data={this.props.data} isAdmin={this.props.isAdmin}/>),
                    addUser: (<LicenseAccessAdd appearance='add'/>)
                }[this.props.type]}
            </React.Fragment>
        )
    }
}

export default LicenseAccessManagement
